var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiSession = function SvgAiSession(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#51C394"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.856 6.855a.643.643 0 0 0-.643.643v7.715c0 1.42 1.15 2.57 2.57 2.571h6.43c.98 0 1.656-.423 2.064-.99a2.796 2.796 0 0 0 .507-1.581.643.643 0 0 0-.642-.643h-1.93V7.498a.643.643 0 0 0-.642-.643H6.856Zm3.857 7.715h3.214V8.14H7.5v7.072c0 .71.575 1.285 1.285 1.285h.002c.218 0 .56-.07.828-.264.236-.17.456-.46.456-1.021 0-.355.288-.643.643-.643Zm.34 1.928h4.16c.562 0 .85-.22 1.021-.456.043-.06.08-.122.111-.187h-5.056a2.448 2.448 0 0 1-.236.643ZM8.784 10.07c0-.355.288-.643.643-.643H12a.643.643 0 0 1 0 1.286H9.427a.643.643 0 0 1-.643-.643Zm.643 1.285a.643.643 0 1 0 0 1.286H12a.643.643 0 0 0 0-1.286H9.427Z",
    clipRule: "evenodd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#51C394"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.566 12.51a5.9 5.9 0 1 1-5.9-5.9m-5.9 5.9h6.808m-.907-5.9a10.185 10.185 0 0 0-2.27 5.9 10.185 10.185 0 0 0 2.27 5.901 10.184 10.184 0 0 0 2.106-4.538m-1.23-4.797c-.344-.06-.344-.555 0-.615a3.123 3.123 0 0 0 2.517-2.409l.02-.095c.075-.342.56-.345.639-.003l.024.11a3.14 3.14 0 0 0 2.524 2.395c.346.06.346.559 0 .62a3.14 3.14 0 0 0-2.524 2.394l-.024.11c-.079.34-.564.339-.64-.002l-.02-.095a3.123 3.123 0 0 0-2.516-2.41Z"
  })));
};
export default SvgAiSession;